<template>
  <div class="password-bd">
    <div class="pwd-wrap ubv">
      <div class="login-hd ub ub-sp ub-xc">
        <div class="header-l">
          <img class="logo" src="@/images/login/logo.png" alt />
        </div>
        <div class="header-r">
          <div class="lang">
            <el-dropdown>
              <span class="dropdown-lang el-dropdown-link">
                {{ activeWebsite }}-{{ activelanguage }}&ensp;
                <i class="icon icon-zhankai"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="width: 210px; border-radius: 8px; padding: 10px 14px">
                <template v-for="(item, idx) in websiteList">
                  <el-dropdown-item :divided="index == 0 && idx !== 0" v-for="(value, index) in item.langList" :key="`${idx}-${index}`" @click.native="changeLanguage(item.domainUrl, value)">
                    <div class="ub">
                      <div class="ub-f1" style="height: 34px; line-height: 34px; font-weight: bold">
                        <span v-if="index == 0">{{ item.websiteName }}</span>
                      </div>
                      <div class="ub-f1" style="height: 34px; line-height: 34px">{{ value.localeName }}{{ index }}</div>
                    </div>
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="wrap ub-f1">
        <div class="login-context ub">
          <div class="ub-f1 login-ad ub ub-xc ub-ac">
            <img style="width: 221px" src="@/images/login/find-pwd.png" alt="" />
          </div>
          <div class="ub-f1">
            <div class="login-box">
              <div class="title ub">
                <div class="ub-f1">
                  <h1>{{ $t('find_password.zhao_hui_mi_ma') }}</h1>
                </div>
              </div>
              <div class="form">
                <div class="input-box ub ub-xc">
                  <div style="width: 16px"></div>
                  <input type="text" v-model="form.email" :placeholder="$t('Common.com_email')" />
                  <div style="width: 16px"></div>
                </div>
                <p class="forword" @click="jump('/login')">
                  <span>{{ $t('find_password.deng_lu') }}</span>
                </p>
                <div class="btn" @click="sendEmail">
                  <span v-if="isLoading">{{ $t('find_password.fa_song_zhong') }}</span>
                  <span v-else>{{ $t('find_password.fszzmmljzyx') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bd">
        <div class="wraps ub ub-xc ub-sp">
          <div class="logo">
            <img src="@/images/login/logo-footer.png" alt="" />
          </div>
          <div class="copyright">
            <p>{{ $t('find_password.dyygdkhqzychzzqjsbyy') }}</p>
            <div>
              <span>Copyright © 2022-2023 ICE. All rights reserved.</span>
              <a href="http://beian.miit.gov.cn/" target="_blank">{{ $t('find_password.yueICPbei15022985hao') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import { setLocale } from '@/locales';

export default {
  data() {
    return {
      websiteList: [],
      langType: [],
      activeWebsite: '',
      activelanguage: '',
      appId: '',
      form: {
        email: '',
        url: '',
        scene: '',
        sessionId: 'ok',
        sig: '',
        ncToken: '',
      },
      isLoading: false,
      loginLanguage: {},
    };
  },
  computed: {
    formValid() {
      return {
        email: { required: true, message: this.$t('find_password.you_xiang_bi_tian') },
      };
    },
  },
  mounted() {
    this.form.url = `${window.location.origin}/resetpassword`;
    this.getLangLogin();
  },
  methods: {
    // 获取站点和语言
    getLangLogin: function () {
      this.$getJSON(apis.DictionaryLangLogin, { websiteType: 2, websiteEnv: 1, domainUrl: window.location.origin }).then((res) => {
        this.websiteList = res.data.websiteList;
        this.langType = res.data.langType;
        const website = res.data.website || { websiteName: this.$t('find_password.wei_pei_zhi_zhan'), defaultLocale: 'CN' };
        const langCode = this.getJump('langCode') || Cookies.get('langCode') || website.defaultLocale;
        this.activeWebsite = website.websiteName;
        const langTypeValueName = this.$listTransObject(this.langType, 'value', 'name');
        this.activelanguage = langTypeValueName[langCode];
        Cookies.set('siteCode', website.websiteCode || '', { path: '/' }); // 记录站点Code
        Cookies.set('mapType', website.mapType || '', { path: '/' }); // 记录地图类型
        Cookies.set('mapRegion', website.mapRegion || '', { path: '/' }); // 记录地图区域
        this.initLoginData(langCode.toLowerCase());
      });
    },
    // 切换语言
    changeLanguage(domainUrl, lang) {
      setLocale(lang.localeCode);
      this.jumpOutside(`${domainUrl}${this.$route.path}`);
    },
    // 获取多语言数据和滑块配置
    initLoginData: async function () {
      this.$getJSON(apis.NcConfig).then((res) => {
        this.appId = res.data.appId;
        this.form.scene = res.data.scene;
      });
    },
    // 发送email成功5秒后返回登录页
    afterSendEmail() {
      const second = 5;
      const context = this;
      const msg = this.$message({
        type: 'success',
        duration: 5000,
        message: this.$t('find_password.fscgomhthdly', [second]),
      });

      // 倒计时函数
      function coutTime(index) {
        setTimeout(() => {
          if (index === 0) {
            // 5s结束后的操作
            context.jump('/login');
          } else {
            msg.message = this.$t('find_password.fscgomhthdly', [index]);
            coutTime(--index);
          }
        }, 1000);
      }
      coutTime(second - 1);
    },
    // 发送重置密码链接
    sendEmail: async function () {
      if (this.isLoading) {
        return;
      }
      const result = await this.$validator(this.formValid, this.form);
      if (result) {
        this.$message.error(result[0].message);
        return;
      }
      this.isLoading = true;
      this.$getJSON(apis.UserSendEmail, this.form)
        .then(() => {
          this.isLoading = false;
          this.afterSendEmail();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.password-bd {
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 568px;
    background-color: #00a0d9;
  }
  .pwd-wrap {
    z-index: 10;
    height: 100%;
    position: relative;
    .wrap {
      width: 1280px;
      margin: 0 auto;
    }
    .login-hd {
      height: 88px;
      padding: 0 28px;
      .header-l {
        img {
          display: block;
          width: 180px;
        }
      }
      .header-r {
        .lang {
          cursor: pointer;
          height: 40px;
          min-width: 176px;
          border: 1px solid rgba(255, 255, 255, 0.6);
          border-radius: 40px;
          padding: 0px 20px 0px 24px;
          .dropdown-lang {
            line-height: 38px;
            color: #ffffff;
            font-size: 14px;
          }
        }
        .lang-item {
          line-height: 82px !important;
        }
      }
    }
    .login-context {
      position: relative;
      overflow: visible;
      width: 750px;
      margin: 0 auto;
      top: 24%;
      border-radius: 16px;
      background-color: #ffffff;
      overflow: hidden;
      box-shadow: 0px 7px 23px rgba(0, 0, 0, 0.05);
      .login-ad {
        background: #f8f9fa;
      }
      .login-box {
        padding: 32px;
        height: 456px;
        .title {
          padding-bottom: 8px;
          h1 {
            color: #202945;
            font-weight: bold;
            font-size: 20px;
            line-height: 28px;
          }
          p {
            margin-top: 8px;
            font-size: 14px;
            color: #818181;
            line-height: 20px;
          }
        }
        .form {
          .input-box {
            height: 50px;
            margin-top: 24px;
            border: 1px solid #e6e6e6;
            border-radius: 8px;
            .label,
            .yc {
              width: 46px;
              cursor: pointer;
              text-align: center;
              .icon {
                font-size: 20px;
                color: #4d4d4d;
              }
            }
            input {
              flex: 1;
              font-size: 16px;
              height: 20px;
              border: none;
              outline: none;
            }
          }
          .forword {
            cursor: pointer;
            margin-top: 16px;
            text-align: right;
            height: 18px;
            font-size: 14px;
            color: #00a0d9;
          }
          .nc-container {
            margin-top: 25px;
            height: 48px;
            .nc_scale {
              height: 48px;
              background: #f5f5f5;
              border-radius: 100px;
              overflow: hidden;
              span {
                height: 48px;
                line-height: 48px;
              }
              .nc_iconfont {
                font-family: 'icon' !important;
                display: flex;
                font-size: 14px;
                &:after {
                  content: '\e818';
                  float: left;
                  margin-left: 10px;
                }
                &.btn {
                  color: transparent;
                }
                &.btn_ok:after {
                  content: '';
                  display: none;
                }
              }
              .btn_slide,
              .btn_ok {
                width: 60px;
                background: linear-gradient(90deg, #95d5ec 0%, #96d5ec 100%);
                border-top-right-radius: 100px;
                border-bottom-right-radius: 100px;
                border: none;
                text-align: center;
                color: #202945;
              }
              .nc_bg {
                width: 0;
                border-top-left-radius: 100px;
                border-bottom-left-radius: 100px;
                background: linear-gradient(90deg, #d0eaf3 0%, #95d5ec 100%);
                &:after {
                  content: '';
                  width: 48px;
                  height: 48px;
                  background-color: red;
                  transform: translateX(10px);
                }
              }
              .nc-lang-cnt {
                display: block;
                color: #202945;
                font-size: 14px;
              }
              .slidetounlock .nc-lang-cnt {
                transform: translateX(22px);
              }
            }
          }
          .btn {
            cursor: pointer;
            margin-top: 24px;
            height: 48px;
            line-height: 48px;
            background: #ffad00;
            border-radius: 100px;
            text-align: center;
            font-weight: bold;
            color: #202945;
          }
        }
      }
      .other-bar {
        margin-top: 37px;
        .bar {
          height: 1px;
          background-color: #e6e6e6;
          flex: 1;
        }
        p {
          color: #818181;
          font-size: 12px;
          padding: 0 20px;
        }
      }
      .other-way {
        margin-top: 15px;
        .way {
          padding: 0 16px;
          .icon {
            font-size: 40px;
          }
        }
      }
    }
  }
  .footer-bd {
    box-shadow: inset 0px 1px 0px #f0f0f0;
    padding: 0 28px;
    .wraps {
      height: 112px;
      line-height: 28px;
    }
    .logo img {
      display: block;
      width: 182px;
    }
    .copyright {
      font-size: 14px;
      line-height: 28px;
      color: rgba(0, 0, 0, 0.45);
      a {
        color: rgba(0, 0, 0, 0.45);
      }
      p {
        line-height: 30px;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
}
</style>
